import { Badge, Form } from "react-bootstrap";
import { useState } from "react";
import { Button, ClickableDiv } from "../styles";
import { client } from "../utils/api";
import BlikCodeInput from "./blikCodeInput";

function PaymentStatus({ order }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [showBlikRetry, setShowBlikRetry] = useState(false);
  async function retryBlik(event) {
    event.preventDefault();
    if (!/^[0-9]{6}$/.test(code)) {
      setError("Wpisz 6-cyfrowy kod BLIK");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await client("orders/blik/charge", {
        method: "POST",
        body: { order: order.id, code },
      });
      setCode("");
      window.location.reload();
    } catch (failure) {
      setError(failure?.json?.detail || "Nie udało się rozpocząć płatności.");
    } finally {
      setBusy(false);
    }
  }
  async function fetchPaymentUrl() {
    const paymentResponse = await client("orders/przelewy24", {
      method: "POST",
      body: { order: order.id },
    });

    window.location.href = paymentResponse.payment_url;
  }

  if (order.payment_type === "cash") {
    return "Gotówka";
  } else if (order.payment_type === "przelewy24") {
    return (
      <span>
        Przelewy24{" "}
        <Badge bg={order.is_paid ? "success" : "secondary"}>
          {order.is_paid ? "Zakończona" : "W toku"}
        </Badge>
        <br />
        {!order.is_paid && (
          <ClickableDiv className="d-inline" onClick={fetchPaymentUrl}>
            spróbuj ponownie
          </ClickableDiv>
        )}
      </span>
    );
  } else if (order.payment_type === "blik") {
    return (
      <div>
        BLIK{" "}
        <Badge bg={order.is_paid ? "success" : "secondary"}>
          {order.is_paid ? "Zakończona" : "W toku"}
        </Badge>
        {!order.is_paid && order.payment_pending && (
          <small className="d-block">
            Potwierdź płatność w aplikacji bankowej. Status odświeży się
            automatycznie.
          </small>
        )}
        {!order.is_paid && !order.payment_pending && (
          <div className="mt-2">
            {!showBlikRetry ? (
              <Button
                type="button"
                primary
                aria-expanded="false"
                aria-controls="blik-retry-form"
                onClick={() => setShowBlikRetry(true)}
              >
                Zapłać ponownie BLIK
              </Button>
            ) : (
              <Form onSubmit={retryBlik} id="blik-retry-form">
                <BlikCodeInput
                  id="order-blik-code"
                  label="Nowy kod BLIK"
                  value={code}
                  onChange={(value) => {
                    setCode(value);
                    setError("");
                  }}
                  error={error}
                  autoFocus
                />
                <Button type="submit" primary disabled={busy} className="mt-2">
                  {busy ? "Przetwarzanie…" : "Zapłać BLIK"}
                </Button>
              </Form>
            )}
          </div>
        )}
      </div>
    );
  } else if (order.payment_type === "card_on_the_spot") {
    return "Karta";
  }

  return null;
}

export default PaymentStatus;
